import { useState } from 'react'
import { toast } from 'sonner'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'

export type PendingChangeKind = 'add' | 'change' | 'remove'

interface PendingChangeActionsProps {
  kind: PendingChangeKind
  isCaiAdmin: boolean
  onApprove: () => Promise<void>
  onReject: () => Promise<void>
}

const KIND_LABELS: Record<PendingChangeKind, string> = {
  add: 'Pending add',
  change: 'Pending change',
  remove: 'Pending removal',
}

export function PendingChangeActions({ kind, isCaiAdmin, onApprove, onReject }: PendingChangeActionsProps) {
  const [isSubmitting, setIsSubmitting] = useState(false)

  async function handle(action: () => Promise<void>) {
    setIsSubmitting(true)
    try {
      await action()
    } catch {
      toast.error('Failed to update pending change')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    // The staff buttons wrap under the badge rather than widening the column, so the table needs no more
    // room for staff than for the customer, who sees only the badge, and switches to cards at the same width.
    <div data-slot="pending-change-actions" className="flex flex-wrap items-center gap-2">
      <Badge variant="secondary" className="w-28! justify-start">
        {KIND_LABELS[kind]}
      </Badge>
      {isCaiAdmin && (
        <div className="flex flex-wrap items-center gap-2">
          <Button size="sm" disabled={isSubmitting} onClick={() => handle(onApprove)}>
            Approve
          </Button>
          <Button variant="outline" size="sm" disabled={isSubmitting} onClick={() => handle(onReject)}>
            Reject
          </Button>
        </div>
      )}
    </div>
  )
}
